import { useSelector } from 'react-redux'

import { BookingRefundPolicy } from '@/models/license'
import { licenseSlice } from '@/store/licenseSlice'
import { RefundPolicyDialogProps } from '../components/RefundPolicyDialog'

export const useRefundPolicyDialogProps = (): RefundPolicyDialogProps => {
  const license = useSelector(licenseSlice.selectors.license)

  return {
    bookingRefundPolicy:
      license?.bookingRefundPolicy ?? BookingRefundPolicy.NEVER,
    licenseName: license?.name || '',
  }
}
